import ResumeItem from './components/ResumeItem';

export const TakesCareComponents = {
  ResumeItem,
};
